<div [ngStyle]="{ width: width + 'px', height: height + 'px' }">
  <svg
    attr.width="{{ width }}px"
    attr.height="{{ height }}px"
    attr.fill="{{ fill }}"
  >
    <use attr.xlink:href="assets/icons/{{ source }}.svg#{{ source }}"></use>
  </svg>
</div>
